module.exports = __webpack_public_path__ + "media/bootstrap-icons/bar-chart-fill-eb449434.svg";